import app from './app';
import {getFirestore, collection} from 'firebase/firestore';

export const db = getFirestore(app);
const firestore = collection(db, 'team_activities');
export default firestore;
